import { status } from '@/main.config.js'
import { DATE_FORMAT } from '@/main.config'
import { unitDuration } from '@/main.config'

export const trainingDate = {
  methods: {
    getTrainingStartDate(training) {
      if (!training) {
        return null
      }
      if (training.status === status.plan || !training.date_start) {
        //в итоге все равно приходится это делать для поддержки старых данных
        return training.date_plan
      }

      return training.date_start
    },
    getTrainingMomentStartDate(training) {
      const startDate = this.getTrainingStartDate(training)
      if (!startDate) {
        return null
      }
      return this.moment.utc(startDate, DATE_FORMAT.serverFull).local()
    },
    getTrainingFormattedStartDate(training, isShort = false) {
      const momentStartDate = this.getTrainingMomentStartDate(training)
      if (!momentStartDate) {
        return null
      }
      return momentStartDate.format(
        isShort
          ? DATE_FORMAT[`${this.$store.getters.LOCALE}Short`]
          : DATE_FORMAT[`${this.$store.getters.LOCALE}`]
      )
    },
    getTrainingEndDate(training) {
      if (!training || !training.date_end) {
        return null
      }
      return training.date_end
    },
    getTrainingMomentEndDate(training) {
      const endDate = this.getTrainingEndDate(training)
      if (!endDate) {
        return null
      }
      return this.moment.utc(endDate, DATE_FORMAT.serverFull).local()
    },
    getTrainingFormattedEndDate(training, isShort = false) {
      const momentEndDate = this.getTrainingMomentEndDate(training)
      if (!momentEndDate) {
        return null
      }
      return momentEndDate.format(
        isShort
          ? DATE_FORMAT[`${this.$store.getters.LOCALE}Short`]
          : DATE_FORMAT[`${this.$store.getters.LOCALE}`]
      )
    },
    getTrainingStartTime(training) {
      const momentStartDate = this.getTrainingMomentStartDate(training)
      if (!momentStartDate) {
        return null
      }
      return momentStartDate.format(DATE_FORMAT.timeHM)
    },
    getTrainingEndTime(training) {
      const momentEndDate = this.getTrainingMomentEndDate(training)
      if (!momentEndDate) {
        return null
      }
      return momentEndDate.format(DATE_FORMAT.timeHM)
    },
    getTrainingMomentCreatedDate(training) {
      const createdAt = training.createdAt
      if (!createdAt) {
        return null
      }
      return this.moment.utc(createdAt, DATE_FORMAT.serverFull).local()
    },
    getDoneTrainingDuration(training) {
      if (training.status !== status.done) {
        return null
      }
      let dateStart = this.moment(training.date_start).local()
      let dateEnd = this.moment(training.date_end).local()
      return dateEnd.diff(dateStart, 'seconds')
    },
    getDurationInMinutes(value, unit) {
      switch (unit) {
        case unitDuration.days:
          return value * 60 * 24
        case unitDuration.hours:
          return value * 60
        case unitDuration.minutes:
          return value
      }
    },
    getDurationWithUnit(duration_minutes, training_duration_unit) {
      let duration_hours = duration_minutes / 60
      let duration_days = duration_hours / 24

      if (training_duration_unit === unitDuration.days) {
        if (
          Number.isInteger(duration_days) ||
          (Math.floor(duration_days) !== 0 && duration_hours % 24 === 12)
        ) {
          return {
            value: duration_days,
            unit: unitDuration.days
          }
        } else if (
          Number.isInteger(duration_hours) ||
          (Math.floor(duration_hours) !== 0 && duration_minutes % 60 === 30)
        ) {
          return {
            value: duration_hours,
            unit: unitDuration.hours
          }
        } else {
          return {
            value: duration_minutes,
            unit: unitDuration.minutes
          }
        }
      } else if (training_duration_unit === unitDuration.hours) {
        if (
          Number.isInteger(duration_hours) ||
          (Math.floor(duration_hours) !== 0 && duration_minutes % 60 === 30)
        ) {
          return {
            value: duration_hours,
            unit: unitDuration.hours
          }
        } else {
          return {
            value: duration_minutes,
            unit: unitDuration.minutes
          }
        }
      } else {
        return {
          value: duration_minutes,
          unit: unitDuration.minutes
        }
      }
    }
  }
}
